import { Route } from '@angular/router';
import { AccessDeniedComponent } from '../common/access-denied/access-denied.component';
import { PageNotFoundComponent } from '../common/page-not-found/page-not-found.component';
import { AuthGuard } from '../shared/guards/auth.guards';
import { FORM_FIELD_APPEARANCE } from '../shared/utils/form-field-appearance.token';
import {
  accountOnboardingRoute,
  managerAccountOnboardingRoute,
} from './account-onboarding/account-onboarding.routes';
import { administrationRoute } from './administration/administration.routes';
import { advisorRoute } from './advisor/advisor.routes';
import { communicationCenterRoute } from './communication-center/communication-center.routes';
import { communicationHubRoute } from './communication-hub/communication-hub.routes';
import { clientDashboardRoute } from './dashboards/client-dashboard/client-dashboard.routes';
import { directOnboardingRoute } from './direct-onboarding/direct-onboarding.routes';
import { managerOnboardingRoute, onboardingRoute } from './onboarding/onboarding.routes';
import { proposalRoute } from './proposal/proposal.routes';

export const privateRoute: Route = {
  path: 'private',
  loadComponent: () =>
    import('../layouts/private/private.component').then((c) => c.PrivateComponent),
  canActivate: [AuthGuard],
  providers: [{ provide: FORM_FIELD_APPEARANCE, useValue: 'outline' }],
  children: [
    {
      path: 'landing',
      loadComponent: () => import('./landing/landing.component').then((c) => c.LandingComponent),
      canActivate: [AuthGuard],
    },
    {
      path: 'whois',
      loadComponent: () => import('./whois/whois.component').then((c) => c.WhoisComponent),
      canActivate: [AuthGuard],
    },
    {
      path: '',
      loadComponent: () =>
        import('../layouts/aside/aside.component').then((c) => c.AsideLayoutComponent),
      canActivate: [AuthGuard],
      children: [
        administrationRoute,
        clientDashboardRoute,
        onboardingRoute,
        managerOnboardingRoute,
        accountOnboardingRoute,
        managerAccountOnboardingRoute,
        directOnboardingRoute,
        advisorRoute,
        proposalRoute,
        communicationCenterRoute,
        communicationHubRoute,
        // TODO: Need to implements
        // {
        //   path: 'help-center',
        //   loadComponent: () =>
        //     import('./private/help-center/help-center.component').then(
        //       (c) => c.HelpCenterComponent,
        //     ),
        // },
      ],
    },
    { path: 'access-denied', component: AccessDeniedComponent },
    { path: '**', component: PageNotFoundComponent },
  ],
};
